import type {TextbookPackingList} from "../packingList.types";

export const packingListModel = ({
                                     accessNumber,
                                     description,
                                     district,
                                     isbn,
                                     medium,
                                     orderDate ="",
                                     orderStatus,
                                     shipDate="",
                                     shipAddress,
                                     studentName,
                                     volumes,
                                 }: Record<string, any> = {}): TextbookPackingList => ({
    accessNumber: accessNumber || "########",
    description,
    district: district || "N/A",
    isbn,
    medium,
    orderDate,
    orderStatus,
    shipDate,
    shipAddress,
    studentName,
    volumes,
});